// src/components/Header.js
import React from 'react';
import { Box, Flex, Button, Icon } from '@chakra-ui/react';
import { FaSignOutAlt, FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  const logout = () => {
    // Clear tokens
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    
    // Redirect to login page
    navigate('/login');
  };

  return (
    <Box
      bg="primary.50"
      color="white"
      w="100%"
      h="60px"
      position="fixed"
      top="0"
      zIndex="1"
      boxShadow="sm"
    >
      <Flex justify="space-between" align="center" maxW="1400px" mx="auto" h="100%" px="4">
        {/* Company Logo or Name */}
        <Flex align="center" gap="2">
          <img
            src="/kovel-argo.svg"
            alt="Kovel Agro Logo"
            style={{ height: '150px' }}
          />
        </Flex>

        {/* Profile Actions */}
        <Flex align="center" gap="4">
          <Button variant="ghost" colorScheme="whiteAlpha" leftIcon={<Icon as={FaUser} />}>
            Профіль
          </Button>
          <Button
            onClick={logout}
            variant="ghost"
            colorScheme="whiteAlpha"
            leftIcon={<Icon as={FaSignOutAlt} />}
          >
            Вийти
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
